import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ChatActionEnum } from 'src/app/models/chat-action.enum';
import { FirebaseChat } from 'src/app/models/firebase-chat.model';
import { FbMeUser, FbYouUser } from 'src/app/models/firebase-user.model';
import { ModalOpenFullimageComponent } from '../modal-open-fullimage/modal-open-fullimage.component';
import { ModalCustomAlertComponent } from '../modal-custom-alert/modal-custom-alert.component';
import { ControllerService } from 'src/app/services/controller.service';
import { Subject, timer } from 'rxjs';
import { ChatroomService } from 'src/app/services/chatroom.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { RolesEnum } from 'src/app/models/roles.enum';
import { NotificationService } from 'src/app/services/notification.service';
import { Preferences } from '@capacitor/preferences';
import { decodeQueryParam } from 'src/helpers';

@Component({
  selector: 'app-chatroom-content',
  templateUrl: './chatroom-content.component.html',
  styleUrls: ['./chatroom-content.component.scss'],
})
export class ChatroomContentComponent implements OnInit, AfterViewInit {
  @ViewChild('chatContent', { static: true }) chatContent: ElementRef<HTMLDivElement>;
  @Input() no_border: boolean;
  @Output() scrollToBottom = new EventEmitter();

  chatroom_id: string;

  isLoading = true;
  alreadyEnded = false;
  isOnline: boolean;

  chats: FirebaseChat[] = [];
  chatActionEnum = ChatActionEnum;

  unreadChat: FirebaseChat;
  bottomChat: FirebaseChat;

  me: FbMeUser;
  you: FbYouUser;

  isRecentlyScrollToBottom = false;

  loadDoneTrigger: Subject<boolean>;

  constructor(
    private modalController: ModalController,
    private controllerService: ControllerService,
    private chatroomService: ChatroomService,
    private route: ActivatedRoute,
    private navController: NavController,
    private authService: AuthService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.initOptionalVariable();

    // this.route.paramMap.subscribe(paramMap => {
    // const id = paramMap.get('id');
    // const id = '90';

    // if (id) {
    //   this.chatroom_id = id;
    // }
    // });
    this.authService.getUser().subscribe({
      next: val => {
        this.me = {
          role: RolesEnum.Customer,
          user: val.user,
        };
        this.you = {
          role: RolesEnum.Admin,
          user: {
            id: null,
          },
        };
        this.chatroomService.setMe(this.me);
        this.chatroomService.setYou(this.you);
      },
    });
    this.readAllChatNotifications();
  }

  scrollToBottomDesktop() {
    const clientHeight = this.chatContent.nativeElement.clientHeight;
    const scrollHeight = this.chatContent.nativeElement.scrollHeight;

    const scrollPosition = scrollHeight - clientHeight;

    // console.log({ el: this.chatContent.nativeElement, clientHeight, scrollHeight, scrollPosition });

    this.chatContent.nativeElement.scrollTop = scrollPosition;
  }

  scrollToBottomHandler(log?: string) {
    if (log) {
      console.log(log);
    }

    const isMobile = window.innerWidth <= 576;
    if (isMobile) {
      this.scrollToBottom.emit();
    } else {
      this.scrollToBottomDesktop();
    }
  }

  ngAfterViewInit() {
    this.loadDoneTrigger = new Subject<boolean>();
    this.loadDoneTrigger.subscribe((trigger: boolean) => {
      if (trigger) {
        // without timer content won't scroll because rendering is not done yet
        const t = timer(1000).subscribe(res => {
          // this.controllerService.dismissLoading();

          if (!this.isRecentlyScrollToBottom) {
            this.scrollToBottomHandler();
            this.isRecentlyScrollToBottom = true;
            setTimeout(() => (this.isRecentlyScrollToBottom = false), 800);
          }

          t.unsubscribe();
        });
      }
    });
    this.getChats(null);
    // this.controllerService.presentLoading({}).then(() => {
    //   // this.updateLastActive();
    // });
  }

  async getChats(event: any, onComplete: () => void = () => {}) {
    const chatroomStorage = decodeQueryParam((await Preferences.get({ key: 'chatroom' })).value);
    const chatroom_id = chatroomStorage.id;
    const isValidUser = chatroomStorage.isValidUser;

    if (!chatroom_id || !isValidUser) {
      this.navController.navigateBack('/tabs/tabHome');
    }

    await this.chatroomService.setChatroomChatCollection(chatroom_id);

    this.chatroomService.getChatroomChats().subscribe({
      next: data => {
        this.chats = data;

        if (this.chats.length > 0 && this.chats[this.chats.length - 1].action === ChatActionEnum.Leave) {
          this.alreadyEnded = true;
        }
        this.bottomChat = null;
        if (this.isOnline) {
          this.bottomChat = this.chats[this.chats.length - 1];
        }
        this.loadDoneTrigger.next(true);
        this.isOnline = true;
        this.isLoading = false;
      },
      error: error => {
        // this.controllerService.dismissLoading().then(() => {});
        const header = 'Error';
        const message = 'Error: ' + error;
        this.controllerService.presentAlert({ header, message, buttons: ['OK'] });
      },
    });
  }

  readAllChatNotifications() {
    this.notificationService.readAllChatNotifications().subscribe({
      next: res => {
        // console.log(res);
      },
    });
  }

  isMe(chat: FirebaseChat) {
    return chat?.sender.id === this.me?.user.id && chat?.sender.role === this.me?.role;
  }

  async openFullImage(image: string) {
    const isMobile = window.innerWidth <= 576;

    const mobileMmodal = await this.modalController.create({
      component: ModalOpenFullimageComponent,
      cssClass: 'modal-bottom',
      componentProps: {
        imgAlert: image,
        useCloseBtn: false,
      },
    });

    const desktopModal = await this.modalController.create({
      component: ModalCustomAlertComponent,
      cssClass: 'modal-bottom modal-fullscreen',
      componentProps: {
        imgAlert: image,
        useCloseBtn: true,
      },
    });

    if (isMobile) {
      mobileMmodal.present();

      const { data, role } = await mobileMmodal.onDidDismiss();

      if (role === 'cancel') {
        return;
      }
    } else {
      desktopModal.present();

      const { data, role } = await desktopModal.onDidDismiss();

      if (role === 'cancel') {
        return;
      }
    }
  }

  protected initOptionalVariable(): void {
    this.isLoading = true;
    this.unreadChat = null;
    this.isOnline = false;
  }
}
